/** Public product name shown in UI */
export const APP_BRAND = "VIVO";
export const APP_BRAND_MARK = "VI";
export const APP_BRAND_TAIL = "VO";
